import { Form, Row, Col, InputGroup } from 'react-bootstrap'

function ModelFilters({ filters, onFilterChange, providers = [] }) {
  const handleChange = (field, value) => {
    onFilterChange({ ...filters, [field]: value })
  }

  return (
    <Row className="g-3 mb-4">
      <Col md={4}>
        <InputGroup>
          <InputGroup.Text>🔍</InputGroup.Text>
          <Form.Control
            type="text"
            placeholder="Rechercher un modèle..."
            value={filters.search || ''}
            onChange={(e) => handleChange('search', e.target.value)}
          />
        </InputGroup>
      </Col>
      <Col md={3}>
        <Form.Select
          value={filters.provider || ''}
          onChange={(e) => handleChange('provider', e.target.value)}
        >
          <option value="">Tous les providers</option>
          {providers.map((p) => (
            <option key={p} value={p}>
              {p}
            </option>
          ))}
        </Form.Select>
      </Col>
      <Col md={3}>
        <Form.Select
          value={filters.type || ''}
          onChange={(e) => handleChange('type', e.target.value)}
        >
          <option value="">Tous les types</option>
          <option value="llm">LLM</option>
          <option value="image">Image</option>
          <option value="video">Video</option>
        </Form.Select>
      </Col>
      <Col md={2}>
        <Form.Select
          value={filters.active || ''}
          onChange={(e) => handleChange('active', e.target.value)}
        >
          <option value="">Tous</option>
          <option value="true">Actifs</option>
          <option value="false">Inactifs</option>
        </Form.Select>
      </Col>
    </Row>
  )
}

export default ModelFilters
